export const SESSION_CAM_EXCLUDE = "sessioncamexclude";
export const SESSION_CAM_HIDE_TEXT = "sessioncamhidetext";
